import { render, staticRenderFns } from "./TelnyxCDR.vue?vue&type=template&id=06fc14a8&scoped=true"
import script from "./TelnyxCDR.vue?vue&type=script&lang=js"
export * from "./TelnyxCDR.vue?vue&type=script&lang=js"
import style0 from "./TelnyxCDR.vue?vue&type=style&index=0&id=06fc14a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc14a8",
  null
  
)

export default component.exports